import { combineReducers } from 'redux';

import storeItems from './store_items';


const rootReducer = combineReducers({
  storeItems
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js